(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5111],{

/***/ 77450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SCREEN */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var SCREEN = {
  DESKTOP: "DESKTOP",
  TABLET: "TABLET",
  MOBILE: "MOBILE"
};

var useResizeScreenModified = function useResizeScreenModified(handler) {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (true) {
      var _window3;

      var handleScreen = function handleScreen() {
        var _window;

        if ((_window = window) !== null && _window !== void 0 && _window.innerWidth) {
          var _window2;

          if (((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.innerWidth) <= 1023) {
            try {
              handler(SCREEN.TABLET);
            } catch (error) {
              console.error();
            }
          } else {
            try {
              handler(SCREEN.DESKTOP);
            } catch (error) {
              console.error();
            }
          }
        }
      };

      handleScreen();
      (_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.addEventListener("resize", handleScreen);
      return function () {
        var _window4;

        /* Clean up function. Remove event before component unmount. */
        (_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.removeEventListener("resize", handleScreen);
      };
    }
  }, []);
};

/* harmony default export */ __webpack_exports__["Z"] = (useResizeScreenModified);

/***/ }),

/***/ 68840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ FiCalendar; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FiCalendar(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "4",
        "width": "18",
        "height": "18",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "2",
        "x2": "16",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "2",
        "x2": "8",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "10",
        "x2": "21",
        "y2": "10"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 38626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var common_functions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98989);
/* harmony import */ var components_atoms_Icon_fi_FiCalendar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68840);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27597);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);





/** ========== */





var PostItem = function PostItem(_ref) {
  var _post$categories;

  var post = _ref.post,
      layout = _ref.layout;
  var category = post === null || post === void 0 ? void 0 : (_post$categories = post.categories) === null || _post$categories === void 0 ? void 0 : _post$categories.nodes.filter(function (item) {
    return item.parent === null;
  });

  if (layout === "vertical") {
    var _post$featuredImage;

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
      className: "flex h-full flex-1 flex-col rounded-3xl bg-white transition-shadow duration-150 hover:shadow-[0px_0px_20px_#7c787833] xl:max-w-sm",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        image: post === null || post === void 0 ? void 0 : (_post$featuredImage = post.featuredImage) === null || _post$featuredImage === void 0 ? void 0 : _post$featuredImage.node,
        wrapper: {
          className: "w-full relative"
        },
        className: "aspect-[16/9] h-full w-full rounded-t-3xl object-cover"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: "flex flex-1 flex-col justify-between p-6",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            as: "h3",
            className: "text-lg font-semibold text-bbc-brand-800 line-clamp-2",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              href: post === null || post === void 0 ? void 0 : post.uri,
              children: post === null || post === void 0 ? void 0 : post.title
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            className: "mt-4 line-clamp-3",
            dangerouslySetInnerHTML: {
              __html: post === null || post === void 0 ? void 0 : post.excerpt
            }
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: "flex flex-wrap justify-between",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: "mt-6 inline-flex items-center rounded-md bg-bbc-brand-800 px-2 py-0.5",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
              src: "/assets/icons/".concat(category[0].name.toLowerCase(), ".svg"),
              alt: "icon",
              width: 16,
              height: 16
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
              className: "inline-block pl-[5px] text-sm font-medium text-white",
              children: category.length > 0 && category[0].name
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: "mt-6 inline-flex items-center",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Icon_fi_FiCalendar__WEBPACK_IMPORTED_MODULE_0__/* .FiCalendar */ .v, {
              size: 18
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
              className: "inline-block pl-2 text-sm",
              children: (0,common_functions__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p)(post === null || post === void 0 ? void 0 : post.date)
            })]
          })]
        })]
      })]
    });
  }

  if (layout === "horizontal") {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: "text-bbc-brand-700",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          as: "h3",
          className: "text-lg font-medium line-clamp-2",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            href: post === null || post === void 0 ? void 0 : post.uri,
            children: post === null || post === void 0 ? void 0 : post.title
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: "mt-6 inline-flex items-center",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Icon_fi_FiCalendar__WEBPACK_IMPORTED_MODULE_0__/* .FiCalendar */ .v, {
            size: 18
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
            className: "inline-block pl-2 text-sm",
            children: (0,common_functions__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p)(post === null || post === void 0 ? void 0 : post.date)
          })]
        })]
      })
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {});
};

/* harmony default export */ __webpack_exports__["Z"] = (PostItem);
PostItem.defaultProps = {
  post: {},
  layout: "vertical"
};
/** ========== */

/***/ }),

/***/ 63353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1216);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);








var AboutUs = function AboutUs(_ref) {
  var data = _ref.data,
      bgImage = _ref.bgImage;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isCount = _useState[0],
      setIsCount = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var detech = function detech() {
      var sectionAboutUs = document.querySelector("#section-about-us");

      if (sectionAboutUs) {
        var sectionAboutUsOffsetTop = sectionAboutUs.offsetTop + 60;

        if (window.pageYOffset > sectionAboutUsOffsetTop - sectionAboutUsOffsetTop / 2) {
          setIsCount(true);
        }
      }
    };

    window.addEventListener("scroll", function () {
      detech();
    });
    window.addEventListener("resize", function () {
      detech();
    });
  }, []);

  var animateCountUp = function animateCountUp(el) {
    var animationDuration = 3000;
    var frameDuration = 1000 / 60;
    var totalFrames = Math.round(animationDuration / frameDuration);

    var easeOutQuad = function easeOutQuad(t) {
      return t * (2 - t);
    };

    var frame = 0;
    var countTo = parseInt(el.innerHTML, 10);
    var counter = setInterval(function () {
      frame++;
      var progress = easeOutQuad(frame / totalFrames);
      var currentCount = Math.round(countTo * progress);

      if (parseInt(el.innerHTML, 10) !== currentCount) {
        // eslint-disable-next-line no-param-reassign
        el.innerHTML = currentCount;
      }

      if (frame === totalFrames) {
        clearInterval(counter);
      }
    }, frameDuration);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (isCount) {
      var counters = document.querySelectorAll(".count");
      counters.forEach(animateCountUp);
    }
  }, [isCount]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("section", {
      id: "section-about-us",
      className: "relative bg-bbc-gradient-liner py-10 lg:py-20",
      children: [bgImage && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_lazyload__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
          src: bgImage,
          alt: "bg about us",
          width: 1920,
          height: 520,
          className: "absolute top-0 left-0 bottom-0 right-0 h-full w-full"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: "container relative z-10",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          text: data === null || data === void 0 ? void 0 : data.title,
          className: "title-h2 mb-6 text-white lg:mb-10"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: "row items-center",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            className: "col-12 lg:col-7",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
              className: "leading-bbc-26 text-white",
              dangerouslySetInnerHTML: {
                __html: data === null || data === void 0 ? void 0 : data.description
              }
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            className: "col-12 mt-7 lg:col-5 lg:mt-0",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
              className: "flex flex-wrap text-white",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
                className: "col-6 text-center",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("p", {
                  className: "mb-4 text-bbc-40px font-semibold lg:text-bbc-48px",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
                    className: "count text-bbc-secondary-300",
                    children: "97"
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
                    className: "text-bbc-secondary-300",
                    children: "% "
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
                    children: "+"
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
                  className: "text-lg",
                  children: "Recommend us"
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
                className: "col-6 relative text-center before:absolute before:top-4 before:bottom-4 before:left-0 before:w-[1px] before:bg-white before:content-[``]",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("p", {
                  className: "mb-4 text-bbc-40px font-semibold lg:text-bbc-48px",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
                    className: "count text-bbc-secondary-300",
                    children: "12"
                  }), " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
                    children: "+"
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
                  className: "text-lg",
                  children: "Years in Business"
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
                className: "col-6 mt-10 text-center",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("p", {
                  className: "mb-4 text-bbc-40px font-semibold lg:text-bbc-48px",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
                    className: "count text-bbc-secondary-300",
                    children: "9000"
                  }), " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
                    children: "+"
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
                  className: "text-lg",
                  children: "Successful cases"
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
                className: "col-6 relative mt-10 text-center before:absolute before:top-4 before:bottom-4 before:left-0 before:w-[1px] before:bg-white before:content-[``]",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("p", {
                  className: "mb-4 text-bbc-40px font-semibold lg:text-bbc-48px",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
                    className: "count text-bbc-secondary-300",
                    children: "2"
                  }), " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
                    children: "Hrs"
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
                  className: "text-lg",
                  children: "Response within"
                })]
              })]
            })
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (AboutUs);
AboutUs.defaultProps = {
  data: {}
};

/***/ }),

/***/ 93008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1216);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var common_functions__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98989);
/* harmony import */ var components_atoms_Icon_fi_FiCalendar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68840);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27597);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31741);
/* harmony import */ var components_molecules_PostItem__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38626);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);












var INISlider = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_2__["default"])(function () {
  return __webpack_require__.e(/* import() */ 2169).then(__webpack_require__.bind(__webpack_require__, 62169));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(62169)];
    },
    modules: ["../components/organisms/IndustryNewsInsights/index.js -> " + "./INISlider"]
  }
});
/** ========== */

var IndustryNewsInsights = function IndustryNewsInsights(_ref) {
  var _data$, _data$$categories;

  var data = _ref.data;
  var category = (_data$ = data[0]) === null || _data$ === void 0 ? void 0 : (_data$$categories = _data$.categories) === null || _data$$categories === void 0 ? void 0 : _data$$categories.nodes.filter(function (item) {
    return item.parent === null;
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("section", {
      className: "hidden lg:block",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
          as: "h2",
          text: "Industry News & Insights",
          className: "mb-10 text-center text-bbc-40px font-semibold text-bbc-brand-800"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
          className: "row",
          children: data.length > 0 && data.map(function (item, index) {
            var _data$2, _data$2$featuredImage, _data$3, _data$4, _data$5, _data$6;

            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
              children: index === 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                className: "col-12",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                  className: "rounded-3xl bg-white transition-shadow duration-150 hover:shadow-[0px_0px_20px_#7c787833]",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
                    className: "flex",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                      className: "col-8 pr-[15px]",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        image: (_data$2 = data[0]) === null || _data$2 === void 0 ? void 0 : (_data$2$featuredImage = _data$2.featuredImage) === null || _data$2$featuredImage === void 0 ? void 0 : _data$2$featuredImage.node,
                        className: "rounded-l-3xl",
                        wrapper: {
                          className: "block"
                        }
                      })
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
                      className: "col-4 flex flex-col justify-center px-[15px] py-4",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        as: "h3",
                        className: "text-xl font-semibold leading-8 text-bbc-brand-800 line-clamp-3",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                          href: (_data$3 = data[0]) === null || _data$3 === void 0 ? void 0 : _data$3.uri,
                          children: (_data$4 = data[0]) === null || _data$4 === void 0 ? void 0 : _data$4.title
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                        className: "mt-6 text-lg text-bbc-brand-900 line-clamp-3",
                        dangerouslySetInnerHTML: {
                          __html: (_data$5 = data[0]) === null || _data$5 === void 0 ? void 0 : _data$5.excerpt
                        }
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
                        className: "mt-6 flex justify-between",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
                          className: "inline-flex items-center rounded-md bg-bbc-brand-800 px-2 py-0.5",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            src: "/assets/icons/".concat(category[0].name.toLowerCase(), ".svg"),
                            alt: "icon",
                            width: 16,
                            height: 16
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
                            className: "inline-block pl-[5px] text-sm font-medium text-white",
                            children: category.length > 0 && category[0].name
                          })]
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
                          className: "inline-flex items-center",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(components_atoms_Icon_fi_FiCalendar__WEBPACK_IMPORTED_MODULE_3__/* .FiCalendar */ .v, {
                            size: 18
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
                            className: "inline-block pl-2 text-sm text-bbc-gray",
                            children: (0,common_functions__WEBPACK_IMPORTED_MODULE_9__/* .formatDate */ .p)((_data$6 = data[0]) === null || _data$6 === void 0 ? void 0 : _data$6.date)
                          })]
                        })]
                      })]
                    })]
                  })
                })
              }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                className: "col-4 mt-10",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(components_molecules_PostItem__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                  post: item
                })
              })
            }, index);
          })
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("section", {
      className: "lg:hidden",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
          className: "title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800",
          children: "Industry News & Insights"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_lazyload__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
          once: true,
          offset: [-100, 100],
          placeholder: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(components_molecules_PostItem__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            post: data[0]
          }),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(INISlider, {
            data: data
          })
        })]
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (IndustryNewsInsights);
IndustryNewsInsights.defaultProps = {
  data: []
};
/** ========== */

/***/ }),

/***/ 90895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ organisms_OurPartners; }
});

// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./components/atoms/LinkRouter/index.js
var LinkRouter = __webpack_require__(27597);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(49711);
;// CONCATENATED MODULE: ./common/hooks/useIntersectionObserver.js


/* eslint-disable react-hooks/exhaustive-deps */


var useIntersectionObserver = function useIntersectionObserver(elementRef, _ref) {
  var _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === void 0 ? 0 : _ref$threshold,
      _ref$root = _ref.root,
      root = _ref$root === void 0 ? null : _ref$root,
      _ref$rootMargin = _ref.rootMargin,
      rootMargin = _ref$rootMargin === void 0 ? "0%" : _ref$rootMargin,
      _ref$freezeOnceVisibl = _ref.freezeOnceVisible,
      freezeOnceVisible = _ref$freezeOnceVisibl === void 0 ? false : _ref$freezeOnceVisibl;

  var _useState = (0,react.useState)(),
      entry = _useState[0],
      setEntry = _useState[1];

  var frozen = (entry === null || entry === void 0 ? void 0 : entry.isIntersecting) && freezeOnceVisible;

  var updateEntry = function updateEntry(_ref2) {
    var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 1),
        entry = _ref3[0];

    setEntry(entry);
  };

  (0,react.useEffect)(function () {
    var node = elementRef === null || elementRef === void 0 ? void 0 : elementRef.current;
    var hasIOSupport = !!window.IntersectionObserver;
    if (!hasIOSupport || frozen || !node) return;
    var observerParams = {
      threshold: threshold,
      root: root,
      rootMargin: rootMargin
    };
    var observer = new IntersectionObserver(updateEntry, observerParams);
    observer.observe(node);
    return function () {
      return observer.disconnect();
    };
  }, [elementRef === null || elementRef === void 0 ? void 0 : elementRef.current, JSON.stringify(threshold), root, rootMargin, frozen]);
  return entry;
};

/* harmony default export */ var hooks_useIntersectionObserver = (useIntersectionObserver);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(68216);
;// CONCATENATED MODULE: ./components/molecules/BubbleLogoRunner/Bubble.js



/* eslint-disable */
var Bubble = function Bubble(id, row, col, top, left, scale) {
  var _this = this;

  (0,classCallCheck/* default */.Z)(this, Bubble);

  (0,defineProperty/* default */.Z)(this, "init", function () {
    var bubbleDom = document.getElementById("bubble-item-".concat(_this.id));

    if (bubbleDom) {
      _this.runnerX = 0;
      _this.runnerY = bubbleDom.offsetTop;
      _this.specificTop = bubbleDom.offsetTop;
      _this.specificLeft = bubbleDom.offsetLeft;
      bubbleDom.style.opacity = 1;
      _this.bubbleDom = bubbleDom;
    }
  });

  (0,defineProperty/* default */.Z)(this, "update", function (panelScrollHeight) {
    if (_this.bubbleDom) {
      if (_this.runnerY > -1 * _this.bubbleDom.offsetHeight) {
        if (_this.mode < 0) {
          _this.mode = _this.runnerX < -5 ? 1 : -1;
        }

        if (_this.mode > 0) {
          _this.mode = _this.runnerX <= 5 ? 1 : -1;
        }

        _this.runnerX += _this.mode / (20 * _this.scale);
        _this.runnerY -= 1;
        _this.bubbleDom.style.top = "".concat(_this.runnerY, "px");
        _this.bubbleDom.style.transform = "translateX(".concat(_this.runnerX, "px) scale(").concat(_this.scale, ")");
      } else {
        _this.runnerY = panelScrollHeight - _this.bubbleDom.offsetHeight;
      }
    }
  });

  this.id = id;
  this.row = row;
  this.col = col;
  this.left = left;
  this.top = top;
  this.scale = scale;
  this.mode = id % 2 === 0 ? 1 : -1;
};


// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/molecules/BubbleLogoRunner/index.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




/* ********** */


var bubbles = [// 1
new Bubble(1, 0, 0, "0px", "0%", 0.75), // Belize bank
new Bubble(2, 0, 1, "120px", "25%", 0.5), // Cayman bank
new Bubble(3, 0, 2, "25px", "65%", 1), // Heritage bank
new Bubble(4, 0, 3, "220px", "55%", 0.75), // CIBC bank
new Bubble(5, 0, 4, "280px", "15%", 0.5), // BEA bank
new Bubble(6, 0, 5, "350px", "75%", 0.75), // DBS bank
// 2
new Bubble(7, 1, 0, "490px", "45%", 1), // Fubon bank
new Bubble(8, 1, 1, "420px", "0%", 0.75), // Hangseng bank
new Bubble(9, 1, 2, "600px", "0%", 0.5), // HSBC bank
new Bubble(10, 1, 3, "650px", "70%", 0.75), // OCBC bank
new Bubble(11, 1, 4, "700px", "30%", 0.75), // Standard bank
new Bubble(12, 1, 5, "830px", "0%", 1), // CITI bank
// 3
// New Bubble(13, 2, 0, "800px", "70%", 0.5),
new Bubble(14, 2, 1, "920px", "45%", 0.75), new Bubble(15, 2, 2, "1020px", "10%", 0.5), new Bubble(16, 2, 3, "1050px", "70%", 0.5), new Bubble(17, 2, 4, "1170px", "45%", 1), new Bubble(18, 2, 5, "1200px", "0%", 0.75), // 4
new Bubble(19, 3, 0, "1320px", "70%", 0.75), new Bubble(20, 3, 1, "1340px", "20%", 0.5), new Bubble(21, 3, 2, "1450px", "45%", 0.5), new Bubble(22, 3, 3, "1500px", "0%", 1), new Bubble(23, 3, 4, "1670px", "20%", 0.5), new Bubble(24, 3, 5, "1620px", "65%", 0.75), // // // 5
new Bubble(25, 4, 0, "1790px", "0%", 0.75), new Bubble(26, 4, 1, "1820px", "60%", 1), new Bubble(27, 4, 2, "1950px", "10%", 0.5), new Bubble(28, 4, 3, "1990px", "60%", 0.5), new Bubble(29, 4, 4, "2120px", "10%", 1), new Bubble(30, 4, 5, "2150px", "60%", 0.75) // // // 6
// New Bubble(31, 5, 0, "2280px", "35%", 0.5),
];

var BubbleElement = function BubbleElement(_ref) {
  var item = _ref.item,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
  var jump = 905;
  var size = 150;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    id: "bubble-item-".concat(item.id),
    className: "shadow-bbc bubble-item absolute inline-block rounded-full bg-no-repeat transition-opacity duration-700",
    style: _objectSpread({
      backgroundImage: "url(/assets/images/common/logo-bubbles.png)",
      backgroundPosition: "".concat(-1 * (size * item.col + item.col), "px ").concat(-1 * (size * item.row + item.row), "px"),
      backgroundSize: "".concat(jump, "px ").concat(jump, "px"),
      width: size,
      height: size,
      opacity: 0,
      left: item.left,
      top: item.top,
      transform: "scale(".concat(item.scale, ")")
    }, style)
  });
};

var BubbleLogoRunner = function BubbleLogoRunner() {
  var bubbleRef = (0,react.useRef)(null);
  var timer = (0,react.useRef)(null);
  var entry = hooks_useIntersectionObserver(bubbleRef, {});
  (0,react.useEffect)(function () {
    var bubblePanel = document.getElementById("bubble-panel");

    if (bubblePanel) {
      bubbles.forEach(function (item) {
        item.init();
      });
      var panelScrollHeight = bubblePanel.scrollHeight;

      var runBubbles = function runBubbles() {
        bubbles.forEach(function (item) {
          item.update(panelScrollHeight);
        });
      };

      timer.current = setInterval(function () {
        if (entry !== null && entry !== void 0 && entry.isIntersecting) {
          runBubbles();
        }
      }, 25);
      return function () {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        clearInterval(timer.current);
      };
    }
  }, [entry === null || entry === void 0 ? void 0 : entry.isIntersecting]); // ******

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "relative flex justify-center overflow-hidden",
    style: {
      height: "430px"
    },
    ref: bubbleRef,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      id: "bubble-panel",
      className: "relative h-full w-4/5",
      children: bubbles.map(function (item, itemIdx) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(BubbleElement, {
          item: item
        }, itemIdx);
      })
    })
  });
};

/* harmony default export */ var molecules_BubbleLogoRunner = (BubbleLogoRunner);
BubbleLogoRunner.defaultProps = {};
;// CONCATENATED MODULE: ./components/organisms/OurPartners/index.js







var OurPartners = function OurPartners(_ref) {
  var button = _ref.button;
  // ******
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "mb-0",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "row",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "col-12 text-center lg:col-6 lg:text-left",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
            className: "title-h2 mb-6 text-bbc-brand-800",
            text: "Our Partners"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "mb-6",
            children: "Join our expanding network of inter-industry professionals in business solutions and gain a competitive edge."
          }), button && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mb-6",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
              href: "/become-our-partner",
              className: "inline-block rounded-[50px] bg-bbc-primary py-2 px-6 text-center text-base font-semibold text-white transition-all hover:bg-bbc-brand-600",
              children: "Become Our Partner"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "col-12 lg:col-6",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
            height: 430,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules_BubbleLogoRunner, {})
          })
        })]
      })
    })
  });
};

/* harmony default export */ var organisms_OurPartners = (OurPartners);
OurPartners.defaultProps = {
  button: false
};

/***/ }),

/***/ 91630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TrustpilotFeedBack; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(88116);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(98352);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./components/atoms/Icon/iconBase.js + 1 modules
var iconBase = __webpack_require__(98851);
;// CONCATENATED MODULE: ./components/atoms/Icon/gr/GrFormNext.js

function GrFormNext(props) {
  return (0,iconBase/* GenIcon */.w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "fill": "none",
        "stroke": "#000",
        "strokeWidth": "2",
        "points": "9 6 15 12 9 18"
      }
    }]
  })(props);
}
;
// EXTERNAL MODULE: ./components/atoms/Icon/si/SiTrustpilot.js
var SiTrustpilot = __webpack_require__(9633);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/organisms/TrustpilotFeedBack/Index.module.scss
var Index_module = __webpack_require__(29850);
var Index_module_default = /*#__PURE__*/__webpack_require__.n(Index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/organisms/TrustpilotFeedBack/index.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var dataStar = new Array(5).fill(1);
var swiper = {
  preloadImages: false,
  lazy: true,
  loop: false,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
    pauseOnMouseEnter: true
  },
  pagination: {
    el: ".swiper-trustpilot-dots",
    clickable: true,
    bulletClass: "bbc-pagination-bullet",
    bulletActiveClass: "bbc-pagination-bullet-active"
  },
  navigation: {
    nextEl: ".swiper-trustpilot-next",
    prevEl: ".swiper-trustpilot-prev"
  },
  slidesPerView: 1,
  spaceBetween: 40
};

var Component = function Component(_ref) {
  var data = _ref.data;

  var _useState = (0,react.useState)(null),
      thumbsSwiper = _useState[0],
      setThumbsSwiper = _useState[1];

  function isImage(url) {
    // eslint-disable-next-line prefer-named-capture-group
    return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "mt-6 justify-between lg:mt-10 lg:flex",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "col-12 lg:col-6",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, _objectSpread(_objectSpread({
        spaceBetween: 10,
        thumbs: {
          swiper: thumbsSwiper
        },
        modules: [swiper_esm/* Autoplay */.pt, swiper_esm/* Navigation */.W_, swiper_esm/* Thumbs */.o3, swiper_esm/* Pagination */.tl]
      }, swiper), {}, {
        className: "swiperFeelback bg-bbc-main ",
        children: data.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
            className: "p-3 lg:p-0",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: " w-full rounded-3xl bg-white py-6 px-8 shadow-[0px_0px_12px_rgba(119,119,119,0.25)] lg:rounded-none  lg:bg-transparent lg:p-0 lg:shadow-none",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex justify-center lg:justify-start",
                children: [isImage(item.avatar) ? /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                  src: item.avatar,
                  className: "mr-6 rounded-full",
                  alt: item.name,
                  width: 80,
                  height: 80
                }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "".concat((Index_module_default()).avatar, " mr-6 flex items-center justify-center rounded-full font-bold"),
                  style: {
                    backgroundColor: item.bgAvatar
                  },
                  children: item.avatar
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: "mb-2  text-bbc-neutral-700",
                    children: item.name
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "flex",
                    children: dataStar.map(function (item, index) {
                      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "mr-1 flex h-6 w-6 items-center justify-center bg-[#00b67a] shadow-md",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SiTrustpilot/* SiTrustpilot */.A, {
                          className: "text-xl text-bbc-white"
                        })
                      }, index);
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "align-items-end mt-3  flex",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "mr-0.5",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SiTrustpilot/* SiTrustpilot */.A, {
                        className: "text-2xl text-[#00b67a]"
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "text-xl font-medium text-bbc-black",
                      children: "Trustpilot"
                    })]
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "my-4 text-center font-semibold text-[#0042A3] opacity-[0.8] lg:text-left",
                children: item.title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: " text-center text-bbc-gray lg:text-left",
                children: item.content
              })]
            })
          }, index);
        })
      }))
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "relative  text-center lg:col-6",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: " hidden lg:flex lg:justify-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
          onSwiper: setThumbsSwiper,
          spaceBetween: 5,
          slidesPerView: 3,
          freeMode: true,
          allowTouchMove: false,
          modules: [swiper_esm/* FreeMode */.Rv, swiper_esm/* Navigation */.W_, swiper_esm/* Thumbs */.o3, swiper_esm/* Pagination */.tl],
          className: "swiperAvatar col-5 mr-2.5 ml-0",
          children: data.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
              className: "text-center",
              children: isImage(item.avatar) ? /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                src: item.avatar,
                className: "cursor-pointer rounded-full",
                alt: "avatar",
                width: 60,
                height: 60
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "mx-auto flex  items-center justify-center rounded-full text-2xl font-bold",
                style: {
                  width: "60px",
                  height: "60px",
                  backgroundColor: item.bgAvatar
                },
                children: item.avatar
              })
            }, index);
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: " mt-6 hidden h-16 lg:block",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "swiper-trustpilot-next absolute flex h-16 w-16 cursor-pointer items-center justify-center rounded-full ".concat((Index_module_default()).btnNext, " "),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(GrFormNext, {
            className: " text-3xl"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "swiper-trustpilot-prev absolute  flex h-16 w-16 cursor-pointer items-center justify-center rounded-full ".concat((Index_module_default()).btnPrev, " "),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(GrFormNext, {
            className: "rotate-180 text-3xl"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "swiper-trustpilot-dots  pt-6 "
      })]
    })]
  });
};

/* harmony default export */ var TrustpilotFeedBack = (Component);

/***/ }),

/***/ 29850:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Index_avatar__N4Fw5","btnNext":"Index_btnNext__swLTJ","btnPrev":"Index_btnPrev__KZ1Lh"};

/***/ }),

/***/ 54356:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"I":[{"name":"Georgi Karov","avatar":"GK","bgAvatar":"#e6f5ee","title":"Lightning fast and precise service!","content":"In my nearly a quarter of century practice, I can hardly name other than BBCIncorp corporate services company with such an instant and straight to the point response with so solid grasp on the needs of the client.","stars":5},{"name":"Siddhant Choyal","avatar":"SC","bgAvatar":"#9df5cc","title":"My #1 recommendation for company registrations","content":"Daisy will guide you through everything and reply almost instantly 100% of the times. If you\'re looking got a HK LTD company, BBCIncorp would be my #1 recommendation. They do above and beyond, it was an absolute breeze working with them.","stars":5},{"name":"Georgi Karov","avatar":"GK","bgAvatar":"#dfeef5","title":"Lightning fast and precise service!","content":"In my nearly a quarter of century practice, I can hardly name other than BBCIncorp corporate services company with such an instant and straight-to-the-point response with so solid grasp on the needs of the client.","stars":5},{"name":"Suraj","avatar":"SU","bgAvatar":"#bfd7e3","title":"Best Service !","content":"I had the pleasure of dealing with Daisy to incorporate my company, the staff at BBCincorp are professional, knowledgable and cost-effective! best service, best price and extremely competent. Would recommend it again !","stars":5},{"name":"Hasitha Dissanayake","avatar":"HD","bgAvatar":"#cdcfc8","title":"Thanks to Laura and the team for their…","content":"Thanks to Laura and the team for their professionalism and responsiveness to assist us in our company formation and bank account opening, can recommend them to anyone.","stars":5},{"name":"Michael Stoeckle","avatar":"MS","bgAvatar":"#cccfc8","title":"Great job is done by BBCIncorp","content":"The team from BBCIncorp was very fast in responding; I had an active and fruitful dialogue while the company was set up: The new venture was fully operational in less than a week which is great.","stars":5},{"name":"Jeremy","avatar":"JE","bgAvatar":"#f4fcc5","title":"Very good company","content":"Very good company. You can trust them. Frankly, this is the first time I have had to deal with a competent accountant. It changes greatly from France ^^. I had lost hope that a competent accountant existed in this world. BBCincorp gave me hope","stars":5},{"name":"Frank Duffy","avatar":"FD","bgAvatar":"#cef4f5","title":"I found BBCIncorp very easy to deal with…","content":"I found BBCIncorp very easy to deal with, they explained everything in detail from the beginning and answered any queries I had very quickly. They were efficient, pleasant to work with & I would have no problem recommending them to anyone.","stars":5},{"name":"Andrii Ch","avatar":"AC","bgAvatar":"#cef6f4","title":"Highly professional and responsive experts","content":"BBC Incorp is one of a kind international legal consultant and advisor of the highest caliber. I especially recommend working with Mrs. Linda Chen, who is a first-class legal specialist.","stars":5}]}');

/***/ })

}]);